"use client"

import { css } from "@emotion/css"

import type { EmbedAttributes } from "@/../types/GutenbergBlockAttributes"

export const TwitterEmbedBlock: React.FC<React.PropsWithChildren<EmbedAttributes>> = (props) => {
  const blob = new Blob(
    [
      // oxlint-disable-next-line i18next/no-literal-string
      `
      <blockquote class="twitter-tweet">
        <a href="${props.url}">Tweet</a>
      </blockquote>
      <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
      `,
    ],

    { type: "text/html" },
  )

  return (
    <iframe
      src={window.URL.createObjectURL(blob)}
      // oxlint-disable-next-line i18next/no-literal-string
      title={"Twitter"}
      // Renders Twitter's own oembed HTML from a same-origin blob; the widget script needs both flags.
      // oxlint-disable-next-line react/iframe-missing-sandbox
      sandbox="allow-scripts allow-same-origin"
      frameBorder="0"
      className={css`
        display: block;
        width: 602px;
        height: 737px;
        margin: 1rem auto;
      `}
    />
  )
}
